// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.foBwr{min-width:210px !important;display:flex;align-items:center;gap:12px}.foBwr.FPxEa{position:relative;display:flex}.foBwr.an8Rg{min-width:0 !important}.XUBnl{flex:1;min-width:0}.D4cdv{position:relative}.RBBvH{display:inline-flex;cursor:pointer;padding-right:8px}.I89Jo{opacity:0;position:absolute;top:8px;left:0;height:100%;width:100%;z-index:-1}.RJuQn{top:50%;left:auto;right:0;width:1px;height:1px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `foBwr`,
	"rootSuffix": `FPxEa`,
	"noMinWidth": `an8Rg`,
	"fullWidthInputWrapper": `XUBnl`,
	"previewWrapper": `D4cdv`,
	"suffixTrigger": `RBBvH`,
	"input": `I89Jo`,
	"inputSuffixAnchor": `RJuQn`
};
export default ___CSS_LOADER_EXPORT___;
